import { render } from "./MasterDataColumnsForm.vue?vue&type=template&id=338e19c3&ts=true"
import script from "./MasterDataColumnsForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataColumnsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__